import { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { QueryKeys } from '@utils/api/query-keys.ts';
import { ExportTemplateResponse } from '@utils/types/organization/export-template.ts';

const fetch = async (): Promise<ExportTemplateResponse> => {
  const { data } = await Axios.get(GET_URL().exportTemplates);
  return data;
};

export const useGetExportTemplates = (
  options?: UseQueryOptions<
    ExportTemplateResponse,
    AxiosError<BaseError>,
    ExportTemplateResponse,
    string[]
  >
) => {
  return useQuery<
    ExportTemplateResponse,
    AxiosError<BaseError>,
    ExportTemplateResponse,
    string[]
  >(QueryKeys.exportTemplates() as string[], fetch, {
    ...options
  });
};
